import React from "react";
import { Box, Skeleton } from "@mui/material";

const GapCardSkeleton = () => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: "18px",
        border: "1px solid #f3c3cf",
        background: "#fff7fa",
      }}
    >
      <Skeleton width="28%" height={28} />
      <Skeleton width="14%" height={18} sx={{ mt: 1 }} />
      <Skeleton width="70%" height={24} sx={{ mt: 1 }} />
      <Skeleton width="54%" height={24} />
    </Box>
  );
};

export default GapCardSkeleton;
